<div>
    <label class="checkbox-group">
        <ng-container *ngIf="label">
            {{ label | translate }}
        </ng-container>
        <input type="checkbox" [checked]="isChecked()" (change)="toggleCheck()" />
        <span class="checkmark"></span>
    </label>
</div>
